import DirectDebitInfo from './direct-debit-info';

export default DirectDebitInfo;
